import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { CloudDownloadOutlined } from '@material-ui/icons'
import { ICreated } from '../../types/date'
import { IContinuationState } from '../../types/continuationScroll'
import { decorateFirst } from '../../services/common'
import * as date from '../../services/date'
import { ContinuationList } from '../../layouts/'
import { P } from '../StyledText'
import { DownloadFileLink } from '../DownloadFileLink'

export interface IRevision extends ICreated {
  version: string
  fileId: string
  fileName: string
  deleted: boolean
}

const withCurrent = (item: IRevision): IRevision => ({
  ...item,
  version: `Current: ${item.version}`,
})

export const RevisionsList = ({
  items,
  continuationToken,
  isLoading,
}: IContinuationState<IRevision>) => (
  <ContinuationList>
    <li className="list-header">
      <P>Revision</P>
      <P>Created by</P>
      <P>Created</P>
    </li>
    {decorateFirst<IRevision>(withCurrent)(items).map(
      (
        { version, created, createdBy: { name }, fileId, deleted }: IRevision,
        i: number
      ) => (
        <DownloadFileLink key={i} fileId={fileId} disabled={deleted}>
          <CloudDownloadOutlined
            className="icon"
            color={deleted ? 'disabled' : 'primary'}
          />
          <P className="revision">{version}</P>
          <P className="name">{name}</P>
          <P className="date">{date.calendar(created, 'FULL')}</P>
        </DownloadFileLink>
      )
    )}
    <li className="list-footer">
      {isLoading ? (
        <CircularProgress />
      ) : !items.length || !continuationToken ? (
        <P className="no-items-text">No more items</P>
      ) : null}
    </li>
  </ContinuationList>
)
